package tta.destinigo.talktoastro.feature_authentication

import tta.destinigo.talktoastro.shared.platform.PlatformType

actual fun getPlatformType(): PlatformType = PlatformType.Web